(ns lupapalvelu.document.shared-tools)

(defn walk-schema
  "Walk the given `schema` collecting results with `f`.

  The result producing function `f` is invoked as `(f state)` for each field,
  where `state` is a map with `:path`, `:element` entries.

  `f` should return a map with at least a `:result` entry.

  The function `f` may optionally support a `:context`, both as an argument entry and as a result entry.
  The `context` represents some arbitrary state generated by `f`, which will be passed from the parent
  nodes to its children.

  Returns the results as a vector."
  [schema f]
  ;; Use loop to avoid recursion and consuming the stack
  (let [body (:body schema)
        path []]
    (loop [results          []
           [entry & others] (when (seq body)
                              [{:path    path
                                :body    body
                                :context {}}])]
      (if (nil? entry)
        results
        (let [{:keys [path body context]} entry
              {:keys [results
                      entries]}           (reduce (fn [acc {:keys [type body] :as element}]
                                                    (let [current-path           (conj path (keyword (:name element)))
                                                          {:keys [result] :as r} (f {:path current-path :element element :context context})
                                                          new-context            (or (:context r) context)]
                                                      (cond-> acc
                                                        result
                                                        (update :results conj result)

                                                        ;; Group, table etc? (but exclude selects as they don't contain fields)
                                                        (and (seq body) (not= "select" type))
                                                        ;; Process the body elements later
                                                        (update :entries conj {:path    current-path
                                                                               :body    body
                                                                               :context new-context}))))
                                                  {:results results
                                                   :entries []}
                                                  body)
              others                      (into others entries)]
          (if (seq others)
            (recur results others)
            results))))))
